import { render } from "./EditAccountDetailsForm.vue?vue&type=template&id=5a5f1153"
import script from "./EditAccountDetailsForm.vue?vue&type=script&lang=js"
export * from "./EditAccountDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__